// 災害対策連絡状態
export const DISASTER_CONTACT_STATUS_MAP = {
    noContact: { code: 1, name: "未連絡" },
    again: { code: 2, name: "再架電" },
    completed: { code: 3, name: "連絡済" },
};
export const DISASTER_CONTACT_STATUSES = [
    DISASTER_CONTACT_STATUS_MAP.noContact,
    DISASTER_CONTACT_STATUS_MAP.again,
    DISASTER_CONTACT_STATUS_MAP.completed
];

// 災害対策対応状態
export const DISASTER_SUPPORT_STATUS_MAP = {
    needService: { code: 1, name: "要出動対応" },
    completed: { code: 2, name: "対応完了" },
};
export const DISASTER_SUPPORT_STATUSES = [
    DISASTER_SUPPORT_STATUS_MAP.needService,
    DISASTER_SUPPORT_STATUS_MAP.completed
];

// 災害対策対応状況サマリ
export const DISASTER_SUPPORT_STATUS_SUMMARY_MAP = {
    progressing: { code: 1, name: "対応中" },
    completed: { code: 2, name: "対応完了" },
};
export const DISASTER_SUPPORT_STATUS_SUMMARIES = [
    DISASTER_SUPPORT_STATUS_SUMMARY_MAP.progressing,
    DISASTER_SUPPORT_STATUS_SUMMARY_MAP.completed
];

// 報告書種別
export const DISASTER_REPORT_TYPE = {
    hospital: 1,
    hospitalSummary: 2,
    mhlw: 3,
};



// WEBPACK FOOTER //
// ./src/utils/disaster.js